import { ComparatorDemoModel } from './comparator-demo.model';

export const ComparatorDemoData: ComparatorDemoModel = {
  content: [
    {
      name: 'Item 1',
      identifier: '11111111',
      description: 'Description 1'
    },
    {
      name: 'Item 2',
      identifier: '222222222',
      description: 'Description 2'
    },
    {
      name: 'Item 3',
      identifier: '333333333',
      description: 'Description 3'
    },
    {
      name: 'Item 4',
      identifier: '44444444',
      description: 'Description 4'
    }
  ]
};
